// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_FAB_FILTER_POPULAR_GROUP: 'ha_fab_filter_popular_group',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_IDA_SERP_GOOGLEONETAP: 'HA_IDA_SERP_GOOGLEONETAP',
    HA_IDA_SERP_HEADER_LOGIN_TEST: 'HA_IDA_SERP_HEADER_LOGIN_TEST',
    HA_IDA_V3_LOGIN_TEST: 'HA_IDA_V3_LOGIN_TEST',
    HA_PULSE_TRIPBOARD_LOADING_ANIMATION_TEST:
        'ha_pulse_tripboard_loading_animation_test',
    HA_PULSE_TRIPBOARD_NEW_MODAL_TEST: 'ha_pulse_tripboard_new_modal_test',
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS',
    HA_SERP_DATES_PROMPT: 'HA_SERP_DATES_PROMPT',
    HA_SERP_DATE_INPUT_COPY: 'HA_SERP_DATE_INPUT_COPY',
    HA_SERP_DESTINATION_URGENCY_MSG: 'HA_SERP_DESTINATION_URGENCY_MSG',
    HA_SERP_DOCK_PAGER_PANEL: 'HA_SERP_DOCK_PAGER_PANEL',
    HA_SERP_FREE_CANCELLATION_V2: 'HA_SERP_FREE_CANCELLATION_V2',
    HA_SERP_MIN_MAX_PRICE_FIELDS: 'HA_SERP_MIN_MAX_PRICE_FIELDS',
    HA_SERP_MOBILE_GEO_DISTANCE: 'HA_SERP_MOBILE_GEO_DISTANCE',
    HA_SERP_NO_COOKIED_TRIPDATA_REDIRECTS:
        'HA_SERP_NO_COOKIED_TRIPDATA_REDIRECTS',
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS',
    HA_SERP_SEARCH_TERM_CAROUSEL: 'HA_SERP_SEARCH_TERM_CAROUSEL',
    HA_SERP_VIRTUAL_TOUR_BADGE: 'HA_SERP_VIRTUAL_TOUR_BADGE',
    HA_SRS_SERIAL_PERCENT_BOOKED: 'HA_SRS_SERIAL_PERCENT_BOOKED',
    HA_URGENCY_HIT_HOVER: 'HA_URGENCY_HIT_HOVER'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
